import { styled, css } from 'styled-components';
import { Box } from '@sendible/design-system/src';

export const Header = styled.div`
  ${() => css`
    align-items: center;
    display: flex;
    width: 100%;

    h2,
    h3 {
      margin: 0;
    }

    .skeleton {
      min-width: 4.875rem;
    }
  `}
`;

export const EmptyStateText = styled.p`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDarkTint50};
    padding: 3rem 0;
    text-align: center;
  `}
`;

export const HeaderContent = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  width: 100%;

  .button {
    &:disabled {
      background: transparent;
      opacity: 0.5;
    }
  }
`;

export const HeadingWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
`;

export const RecipientsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 0;
`;

export const ActionGroup = styled.div`
  ${({ theme: { colors } }) => css`
    align-items: center;
    display: flex;

    .skeleton {
      min-width: 5rem !important;
    }

    .approve-button {
      .icon {
        path {
          stroke: ${colors.semanticSuccessShade10};
        }
      }
    }

    .reject-button {
      .icon {
        path {
          stroke: ${colors.semanticDanger};
        }
      }
    }
  `}
`;

export const DeleteModalActions = styled(Box)`
  gap: 0.5rem;
  margin-top: 1rem;
  width: 100%;

  .button {
    flex: 1;
  }
`;
